import Vue from "vue";
import VueRouter from "vue-router";
import Live from "./pages/Streaming.vue";
import Home from "./pages/Home.vue";
import QrCode from "./pages/QrCode.vue";
import Error from "./pages/Error.vue";
import Store from "./utils/store";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    beforeEnter: (to, from, next) => {
      const flag = Store.existingSession();

      if (flag && to.name !== "live") {
        next({ name: "live" });
      } else if (!flag && to.name === "live") {
        next({ name: "qrcode" });
      } else {
        console.log("*** new session started ***");
        next();
      }
    },

    children: [
      {
        path: "",
        name: "qrcode",
        component: QrCode,
      },
      {
        path: "/live",
        name: "live",
        component: Live,
      },
      {
        path: "/error",
        name: "error",
        props: true,
        component: Error,
      },
      {
        path: "/*",
        redirect: { name: 'live' },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
